import { render, staticRenderFns } from "./BookingStatusSelect.vue?vue&type=template&id=d95f6d20&"
import script from "./BookingStatusSelect.vue?vue&type=script&lang=js&"
export * from "./BookingStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports